'use strict'

const cloneDeep_ = require('lodash/cloneDeep')

const defaultAdapter = require('./defaultAdapter')
const gridAdapter = require('./gridAdapter')
const dropdownOptionsAdapter = require('./dropdownOptionsAdapter')
const galleryAdapter = require('./galleryAdapter')
const uploadButtonAdapter = require('./uploadButtonAdapter')
const nullAdapter = require('./nullAdapter')
const connectedRepeaterAdapter = require('./repeater/connectedRepeaterAdapter')
const detailsRepeaterAdapter = require('./repeater/detailsRepeaterAdapter')
const paginationAdapter = require('./paginationAdapter')
const queryResults = require('../helpers/queryResults')
const {
  setCurrentIndex,
  updateFields,
  refresh,
  fetchCurrentPage,
  doFetch
} = require('../records/actions')
const {
  selectCurrentRecordIndex
} = require('../dataset-controller/rootReducer')

const {
  GRID,
  DROPDOWN_OPTIONS,
  GALLERY,
  UPLOAD_BUTTON,
  DETAILS_DATASET,
  REPEATER,
  PAGINATION,
  DETAILS_REPEATER
} = require('../componentRoles')

module.exports = ({
  adapterParams,
  dispatch,
  recordStore,
  componentAdapterContexts
}) => {
  const rolesToApis = {
    default: defaultAdapter(adapterParams),
    [GRID]: gridAdapter(adapterParams),
    [DROPDOWN_OPTIONS]: dropdownOptionsAdapter(adapterParams),
    [GALLERY]: galleryAdapter(adapterParams),
    [UPLOAD_BUTTON]: uploadButtonAdapter(adapterParams),
    [DETAILS_DATASET]: nullAdapter(adapterParams),
    [REPEATER]: connectedRepeaterAdapter(adapterParams),
    [PAGINATION]: paginationAdapter(adapterParams),
    [DETAILS_REPEATER]: detailsRepeaterAdapter(adapterParams)
  }
  const apiOf = ({ role }) => rolesToApis[role] || rolesToApis.default

  const actions = {
    fetchRecordById: (recordId, byRefField) =>
      recordStore(byRefField).chain(service => service.getRecordById(recordId)),

    fetchAll: byRefField => doFetch(recordStore, 0, 1000, byRefField),

    fetchCurrentItems: state =>
      fetchCurrentPage(recordStore, state).catch(() =>
        queryResults.Empty().get()
      ),

    fetchOne: () => doFetch(recordStore, 0, 1),

    fetch: (...args) => doFetch(recordStore, ...args),

    getInitialData: () =>
      recordStore().matchWith({
        Nothing: () => queryResults.Empty(),
        Just: ({ value: service }) => service.getSeedRecords()
      }),

    setCurrentIndex: (...args) => dispatch(setCurrentIndex(...args)),

    setFieldInCurrentRecordAndSynchronize: (
      field,
      value,
      componentIdToExcludeFromUpdatingComponentsBasedOnRecord
    ) => {
      return dispatch(
        updateFields(
          { [field]: cloneDeep_(value) },
          componentIdToExcludeFromUpdatingComponentsBasedOnRecord
        )
      )
    },

    refresh: () => dispatch(refresh()),

    isCurrentRecordNew: state =>
      recordStore().matchWith({
        Nothing: () => false,
        Just: ({ value: service }) =>
          service.isNewRecord(selectCurrentRecordIndex(state))
      }),

    isCurrentRecordPristine: state =>
      recordStore().matchWith({
        Nothing: () => false,
        Just: ({ value: service }) =>
          service.isPristine(selectCurrentRecordIndex(state))
      })
  }

  const api = {
    isValidContext: componentAdapterContext =>
      apiOf(componentAdapterContext).isValidContext(componentAdapterContext),

    bindToComponent: () =>
      componentAdapterContexts.map(componentAdapterContext =>
        apiOf(componentAdapterContext).bindToComponent(
          componentAdapterContext,
          actions,
          api
        )
      ),

    currentRecordModified: (updatedFields = [], compIdToFilter = null) =>
      componentAdapterContexts
        .filter(
          context =>
            !compIdToFilter || context.component.uniqueId !== compIdToFilter
        )
        .map(componentAdapterContext =>
          apiOf(componentAdapterContext).currentRecordModified(
            componentAdapterContext,
            actions,
            updatedFields,
            api
          )
        ),

    recordSetLoaded: () =>
      componentAdapterContexts.map(componentAdapterContext =>
        apiOf(componentAdapterContext).recordSetLoaded(
          componentAdapterContext,
          actions,
          api
        )
      ),

    currentViewChanged: () =>
      componentAdapterContexts.map(componentAdapterContext =>
        apiOf(componentAdapterContext).currentViewChanged(
          componentAdapterContext,
          actions,
          api
        )
      ),

    currentIndexChanged: () =>
      componentAdapterContexts.map(componentAdapterContext =>
        apiOf(componentAdapterContext).currentIndexChanged(
          componentAdapterContext,
          actions,
          api
        )
      )
  }

  return api
}



// WEBPACK FOOTER //
// ./adapters/adapterApi.js